document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.sm-header');
  const toggles = document.querySelectorAll('[data-sm-menu-toggle]');
  const setMenu = (open) => {
    if (!header) return;
    header.setAttribute('data-menu-open', String(open));
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
  };

  if (header && toggles.length) {
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        setMenu(header.getAttribute('data-menu-open') !== 'true');
      });
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) setMenu(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMenu(false);
    });
  }

  if (header) {
    let compactFrame = 0;
    let compact = header.getAttribute('data-compact') === 'true';
    const collapsePoint = () => window.matchMedia('(max-width: 760px)').matches ? 112 : 202;
    const setCompactHeader = (nextCompact) => {
      if (compact === nextCompact) return;
      compact = nextCompact;
      header.setAttribute('data-compact', String(compact));
      if (compact) setMenu(false);
    };
    const updateCompactHeader = () => {
      compactFrame = 0;
      const scrollTop = Math.max(0, window.scrollY);
      if (!compact && scrollTop > collapsePoint()) setCompactHeader(true);
      else if (compact && scrollTop <= 8) setCompactHeader(false);
    };
    const scheduleCompactHeader = () => {
      if (!compactFrame) compactFrame = window.requestAnimationFrame(updateCompactHeader);
    };

    window.addEventListener('scroll', scheduleCompactHeader, { passive: true });
    window.addEventListener('resize', scheduleCompactHeader, { passive: true });
    updateCompactHeader();
  }

  document.querySelectorAll('[data-sm-hero]').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('[data-sm-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-sm-hero-dot]'));
    const previous = hero.querySelector('[data-sm-hero-prev]');
    const next = hero.querySelector('[data-sm-hero-next]');
    if (slides.length < 2) return;

    const interval = Number.parseInt(hero.dataset.smHeroInterval || '7000', 10);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = 0;
    let touchStartX = 0;

    const stop = () => {
      if (!timer) return;
      window.clearTimeout(timer);
      timer = 0;
    };
    const paused = () => document.hidden || hero.matches(':hover') || hero.contains(document.activeElement);
    const start = () => {
      stop();
      if (reducedMotion || paused()) return;
      timer = window.setTimeout(() => activate(current + 1), interval);
    };
    const activate = (nextIndex) => {
      current = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, index) => {
        const active = index === current;
        dot.setAttribute('aria-selected', String(active));
        dot.setAttribute('tabindex', active ? '0' : '-1');
      });
      start();
    };

    previous?.addEventListener('click', () => activate(current - 1));
    next?.addEventListener('click', () => activate(current + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => activate(index)));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', (event) => {
      if (!hero.contains(event.relatedTarget)) start();
    });
    hero.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') activate(current - 1);
      if (event.key === 'ArrowRight') activate(current + 1);
    });
    hero.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
      stop();
    }, { passive: true });
    hero.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) > 45) activate(current + (distance < 0 ? 1 : -1));
      else start();
    }, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    activate(current);
  });

  document.querySelectorAll('[data-sm-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-sm-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-sm-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        if (!src) return;
        main.setAttribute('src', src);
        main.setAttribute('alt', thumb.getAttribute('data-alt') || 'Product image');
        thumbs.forEach((item) => item.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('[data-sm-variant-select]').forEach((select) => {
    const product = select.closest('.sm-template');
    if (!product) return;
    const price = product.querySelector('[data-sm-product-price]');
    const compare = product.querySelector('[data-sm-compare-price]');
    const sku = product.querySelector('[data-sm-sku-value]');
    const stock = product.querySelector('[data-sm-stock-status]');
    const addButton = product.querySelector('[data-sm-add-button]');
    const addLabel = product.querySelector('[data-sm-add-label]');
    const mainImage = product.querySelector('[data-sm-gallery-main]');
    const saleBadge = product.querySelector('[data-sm-sale-badge]');
    const saleLabel = product.querySelector('[data-sm-sale-label]');
    const priceContainer = price?.closest('.sm-price');

    const updateVariant = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const comparePrice = option.dataset.comparePrice || '';
      const discount = option.dataset.discount || '';
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = comparePrice;
        compare.hidden = !comparePrice;
      }
      if (saleLabel) saleLabel.hidden = !comparePrice;
      priceContainer?.classList.toggle('sm-price--sale', Boolean(comparePrice));
      if (saleBadge) {
        saleBadge.textContent = discount ? `-${discount}%` : '';
        saleBadge.hidden = !comparePrice;
      }
      if (sku) sku.textContent = option.dataset.sku || '';
      if (stock) {
        stock.textContent = available ? 'Available' : 'Currently unavailable';
        stock.classList.toggle('sm-stock--out', !available);
      }
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (mainImage && option.dataset.image) mainImage.setAttribute('src', option.dataset.image);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    };

    select.addEventListener('change', updateVariant);
  });

  document.querySelectorAll('[data-sm-preview-add]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.sm-cart-count').forEach((count) => {
        count.textContent = String((Number.parseInt(count.textContent || '0', 10) || 0) + 1);
      });
      const label = button.querySelector('[data-sm-add-label]');
      const status = button.closest('.sm-purchase')?.querySelector('[data-sm-add-status]');
      if (label) label.textContent = 'Added to cart';
      if (status) status.hidden = false;
      window.setTimeout(() => {
        if (label) label.textContent = 'Add to cart';
      }, 1600);
    });
  });

  document.querySelectorAll('[data-sm-preview-contact]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const status = form.querySelector('[data-sm-form-status]');
      if (!status) return;
      status.hidden = false;
      status.focus?.();
    });
  });

  document.querySelectorAll('[data-sm-preview-account]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const status = form.querySelector('[data-sm-account-status]');
      if (status) status.hidden = false;
    });
  });
});
